import React from "react";
import { connect } from "react-redux";
import { getParentElementWithChildren } from "@whalecloud/page-builder-core/selectors";
import { set } from "dot-prop-immutable";
import { Collapse, SimpleForm as Form, Radio, Input, Select, Switch } from '@whalecloud/fdx';
import { toolFormAttr, toolCollapseAttr, getLocale } from '@utils/util';
import SelectIcon from '@components/SelectIcon';
import CommonStyleSettings from '@whalecloud/page-builder-base-components/components/ElementSettings/CommonStyleSettings';

const { Panel } = Collapse;
const { Option } = Select;

const valueKey = 'data.formItemSettings';

const ButtonSettings = ({ element, parentElement, updateElement }) => {
  const messages = getLocale();

  const { formItemSettings = {} } = element.data;
  const { data = {} } = parentElement || {};
  const { settings = {} } = data;
  const { align = 'center' } = settings;
  const {
    text,
    type,
    ghost = false,
    htmlType = 'button',
    disabled,
    icon: btnIcon
  } = formItemSettings;

  const initialValues = {
    text,
    type,
    ghost,
    htmlType,
    disabled,
    align
  };

  const onFormChange = (obj: Object) => {
    Object.keys(obj).forEach((key: string) => {
      let propName = `${valueKey}.${key}`;
      let newElement;
      if (key === 'align') {
        propName = `data.settings.${key}`;
        newElement = set(parentElement, propName, obj[key]);
      } else {
        newElement = set(element, propName, obj[key]);
      }
      updateElement({
        element: newElement,
      });
    });
  };

  const handleConfirm = (icon) => {
    onFormChange({ icon });
  }

  return (
    <Collapse {...toolCollapseAttr} defaultActiveKey={['1']}>
      <Panel header={messages['PAGEBUIDER_SETTINGS']} key="1">
        <Form
          {...toolFormAttr}
          layout="horizontal"
          name="form_in_modal"
          initialValues={initialValues}
          onValuesChange={onFormChange}
        >
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TEXT']} name="text">
            <Input />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_TYPE']} name="type">
            <Select>
              <Option value="primary">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_PRIMARY']}</Option>
              <Option value="dashed">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DASHED']}</Option>
              <Option value="danger">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DANGER']}</Option>
              <Option value="link">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_LINK']}</Option>
              <Option value={null}>{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_STYLE_DEFAULT']}</Option>
            </Select>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_GHOST']} name="ghost" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_HTML_TYPE']} name="htmlType">
            <Select>
              <Option value="submit">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_SUBMIT']}</Option>
              <Option value="reset">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_RESET']}</Option>
              <Option value="button">{messages['PAGEBUIDER_SETTINGS_BTN_TYPE_HTML_BUTTON']}</Option>
            </Select>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_ICON']} name="icon">
            <SelectIcon defaultIcon={btnIcon} onConfirm={handleConfirm} />
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_BUTTON_ALIGN']} name="align">
            <Radio.Group buttonStyle="solid" size="small">
              <Radio.Button value="form">{messages['PAGEBUIDER_SETTINGS_FORM']}</Radio.Button>
              <Radio.Button value="left">{messages['PAGEBUIDER_SETTINGS_LEFT']}</Radio.Button>
              <Radio.Button value="center">{messages['PAGEBUIDER_SETTINGS_CENTER']}</Radio.Button>
              <Radio.Button value="right">{messages['PAGEBUIDER_SETTINGS_RIGHT']}</Radio.Button>
            </Radio.Group>
          </Form.Item>
          <Form.Item label={messages['PAGEBUIDER_SETTINGS_DISABLED']} name="disabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
        <CommonStyleSettings />
      </Panel>
    </Collapse>
  );
};

export default connect<any, any, any>(
  (state, { element }) => {
    return { parentElement: getParentElementWithChildren(state, element.id) }
  }
)(React.memo(ButtonSettings));
